// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthAlert_container__3l8gu"};